// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import css from './EmployeeCard.css'
import FeelingsMeter from './FeelingsMeter'
import IncentivesPanel from './incentivesPanel/IncentivesPanel'
const BASE_PATH = '/tyontekijakortti'
type EmployeeCardProps = {
  history: Record<string, any>
  location: Record<string, any>
}
type Tab = {
  label: string
  value: string
}

class EmployeeCard extends React.Component<EmployeeCardProps> {
  getTabs = (): Tab[] => {
    return [
      {
        label: i18n.t('employeeCard.counterTab'),
        value: 'aloitteellinen-ja-peukutettavat',
      },
      {
        label: i18n.t('employeeCard.feelingsTab'),
        value: 'fiilismittari',
      },
    ]
  }
  onTabClick = (tab) => {
    const { history } = this.props
    history.push(`${BASE_PATH}/${tab.value}`)
  }
  getActiveTab = () => {
    const { location } = this.props
    const activeTab: Tab = this.getTabs().find((tab) => location.pathname.includes(tab.value))

    if (activeTab) {
      return activeTab.value
    } else {
      return 'aloitteellinen-ja-peukutettavat'
    }
  }

  render() {
    return (
      <div className={css.component}>
        <span id={'#top'} />
        <Header
          title={i18n.t('employeeCard.header')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('employeeCard.header')}</Typography>
          <Switch>
            <Route exact path='/tyontekijakortti/fiilismittari' component={FeelingsMeter} />
            <Route path='/tyontekijakortti/fiilismittari/:date' component={FeelingsMeter} />
            <Route exact path='/tyontekijakortti/aloitteellinen-ja-peukutettavat' component={IncentivesPanel} />
            <Route path='/tyontekijakortti/aloitteellinen-ja-peukutettavat/:date' component={IncentivesPanel} />
            <Route exact path='/tyontekijakortti/' component={IncentivesPanel} />
            <Route path='/tyontekijakortti/:date' component={IncentivesPanel} />
            <Redirect from='/tyontekijakortti/' to='/tyontekijakortti' />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(EmployeeCard)
